<div class="ctn">
	<div class="clear-btn" (click)="remove()">
		<ion-icon name="close"></ion-icon>
	</div>
	<div (click)="openDrawingModal()">
		<calao-drawing [showClearButton]="false" [showUndoButton]="false" [readonly]="true" [base64Data]="drawing"
			[missingDrawingText]="params.missingDrawingText || ''">
		</calao-drawing>
	</div>
</div>